import { useState } from "react";
import { Reveal, Stagger, StaggerItem } from "../components/Motion";
import { certificates } from "../lib/data";
import { Dialog, DialogContent, DialogTrigger } from "../components/ui/dialog";
import { X } from "lucide-react";

export default function Certificates() {
  const [active, setActive] = useState(null);

  return (
    <div data-testid="page-certificates">
      <section className="pt-32 md:pt-40 pb-16">
        <div className="container-luxe">
          <Reveal>
            <div className="overline mb-6">Сертифікати</div>
          </Reveal>
          <Reveal delay={0.05}>
            <h1 className="font-serif text-5xl md:text-7xl lg:text-[88px] leading-[0.95] tracking-tight max-w-4xl">
              Освіта та сертифікація
            </h1>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-8 text-warmGray text-lg max-w-2xl leading-relaxed">
              Сертифікати провідних європейських академій та міжнародні дипломи.
              Натисніть на документ, щоб відкрити в повному розмірі.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="pb-24 md:pb-32">
        <div className="container-luxe">
          <Stagger className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {certificates.map((c, i) => (
              <StaggerItem key={c.title}>
                <Dialog onOpenChange={(o) => !o && setActive(null)}>
                  <DialogTrigger asChild>
                    <button
                      data-testid={`cert-${i}`}
                      onClick={() => setActive(c)}
                      className="group block w-full text-left rounded-3xl overflow-hidden border border-line bg-bone hover:border-nudeDark transition"
                    >
                      <div className="overflow-hidden bg-sand">
                        <img loading="lazy" decoding="async" src={c.src} alt={c.title} className="w-full h-72 object-cover transition-transform duration-700 group-hover:scale-[1.04]" />
                      </div>
                      <div className="p-6">
                        <div className="overline mb-2 text-warmGray">{c.year}</div>
                        <h3 className="font-serif text-xl md:text-2xl leading-tight">{c.title}</h3>
                        <p className="mt-2 text-sm text-warmGray">{c.description}</p>
                      </div>
                    </button>
                  </DialogTrigger>
                  <DialogContent className="max-w-3xl bg-bone p-0 border-line">
                    <div className="relative">
                      <img loading="lazy" decoding="async" src={c.src} alt={c.title} className="w-full max-h-[80vh] object-contain bg-sand" />
                      <div className="p-6 border-t border-line">
                        <div className="overline text-warmGray mb-2">{c.year}</div>
                        <h3 className="font-serif text-2xl md:text-3xl">{c.title}</h3>
                        <p className="text-warmGray mt-2 text-sm">{c.description}</p>
                      </div>
                    </div>
                  </DialogContent>
                </Dialog>
              </StaggerItem>
            ))}
          </Stagger>
        </div>
      </section>
    </div>
  );
}
